import Vue from 'vue'
import Vuex from 'vuex'
import publicData from './publicData'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        publicData
    }
})
